const CheckmarkFilled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m3.893-11.6-5.54 5.558-2.246-2.265a.48.48 0 0 0-.355-.14.477.477 0 0 0-.493.494q0 .214.14.353l2.39 2.37q.241.242.565.242.322 0 .565-.242L16.6 9.607a.48.48 0 0 0 .14-.355.477.477 0 0 0-.494-.493.47.47 0 0 0-.353.14"
      clipRule="evenodd"
    />
  </>
)
export default CheckmarkFilled
